import { useState, useEffect, useRef } from "react";
import Image from "next/image";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { submitCommentInChat } from "../../../../../redux/actions/chat.actions";
import { ConditionName } from "../../../../../interfaces";
import { conditions } from "../../../../../helpers";
import IMAGES from "../../../../../images/importImages";
import { setChatEmojisPopover } from "../../../../../redux/slices/popoversSlice";
import { getLoginZarebinUrl } from "../../../../../services";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import InstagramEmoji from "../InstagramEmoji/InstagramEmoji";

const EmojiPicker = dynamic(() => import("../emojiPicker/emojiPicker"));
const DefaultMessages = dynamic(() => import("./defaultMessages"));

const AddChatComment = () => {
    const [inputValue, setInputValue] = useState<string>("");
    const [selectedEmoji, setSelectedEmoji] = useState<string>("");

    const inputValueRef = useRef<string>(inputValue);
    const selectedEmojiRef = useRef<string>(selectedEmoji);

    useEffect(() => {
        inputValueRef.current = inputValue;
    }, [inputValue]);

    useEffect(() => {
        selectedEmojiRef.current = selectedEmoji;
    }, [selectedEmoji]);

    const dispatch = useAppDispatch();
    const { chatEmojisPopover } = useAppSelector(({ popovers: { chatEmojisPopover } }) => ({ chatEmojisPopover }), shallowEqual);
    useAppSelector(({ chats: { chatEnabled, defaultMessages } }) => ({ chatEnabled, defaultMessages }), shallowEqual);
    useAppSelector(
        ({ videoData: { isComplexDesktop, isComplexPortrait } }) => ({
            isComplexDesktop,
            isComplexPortrait
        }),
        shallowEqual
    );
    useAppSelector(({ user: { isLogin, settings } }) => ({ isLogin, settings }), shallowEqual);

    useEffect(() => {
        if (selectedEmoji) {
            setInputValue(`${inputValue}${selectedEmoji}`);
            setSelectedEmoji("");
        }
    }, [selectedEmoji]);

    useEffect(() => {
        const handleSendCommentInputKeyPress = (event: any) => {
            if (event.key === "Enter" && event.target.id === "send-chat-input" && (!!inputValueRef.current || !!selectedEmoji))
                submitCommentInChat(setInputValue, inputValueRef.current);
        };
        document.addEventListener("keypress", handleSendCommentInputKeyPress);
        return () => document.removeEventListener("keypress", handleSendCommentInputKeyPress);
    }, []);

    if (conditions(ConditionName.isComplexPortrait)) {
        return (
            <div className={`pl-absolute pl-bottom-0 pl-flex-none pl-w-full pl-flex pl-flex-col pl-justify-end`}>
                <div className="pl-fixed pl-top-[63px] pl-w-full pl-border-t pl-border-b pl-border-z-scondary dark:pl-border-z-secondary-500 pl-py-2 !pl-bg-white dark:!pl-bg-dark-3 pl-px-4">
                    {conditions(ConditionName.isLogin) ? (
                        <>
                            {conditions(ConditionName.chatEnabled) ? (
                                <div className={`pl-flex pl-items-center pl-gap-1`}>
                                    <div className="pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px]">
                                        <Image
                                            alt="emoji-list-icon"
                                            src={
                                                conditions(ConditionName.isDarkMode)
                                                    ? chatEmojisPopover
                                                        ? IMAGES.emojiHappyWhite
                                                        : IMAGES.keyboardWhite
                                                    : chatEmojisPopover
                                                    ? IMAGES.emojiHappyBlack
                                                    : IMAGES.keyboardBlack
                                            }
                                            onClick={() => dispatch(setChatEmojisPopover(!chatEmojisPopover))}
                                            className="pl-cursor-pointer"
                                            width={24}
                                            height={24}
                                        />
                                        <input
                                            id="send-chat-input"
                                            className={`pl-text-gray-600 pl-pt-[2px] dark:pl-text-secondary pl-font-normal placeholder:pl-text-gray-600 placeholder:dark:pl-text-secondary pl-w-full pl-bg-transparent pl-outline-none pl-border-none pl-text-[12px]`}
                                            placeholder="دیدگاه خود را وارد کنید"
                                            onChange={(event: any) => setInputValue(event.target.value)}
                                            maxLength={200}
                                            value={inputValue}
                                        />
                                        <div className="pl-text-[11px] pl-font-normal">
                                            <span>{inputValue.length}</span>
                                            <span>/</span>
                                            <span>200</span>
                                        </div>
                                    </div>
                                    <Image
                                        alt="send-comment"
                                        src={IMAGES.sendCommentTouchScreen}
                                        onClick={(e: any) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            submitCommentInChat(setInputValue, inputValue);
                                        }}
                                        className="pl-cursor-pointer"
                                        width={40}
                                        height={40}
                                    />
                                </div>
                            ) : (
                                <p
                                    className={`pl-w-full pl-truncate pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px] pl-text-[14px] pl-font-normal pl-text-secondary/[0.7]`}
                                >
                                    در حال حاضر امکان ثبت دیدگاه وجود ندارد.
                                </p>
                            )}
                        </>
                    ) : (
                        <p
                            className={`pl-w-full pl-truncate pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px] pl-text-secondary pl-text-[14px] pl-font-normal`}
                        >
                            شما برای ارسال دیدگاه خود باید{" "}
                            {conditions(ConditionName.isZarebinSite) ? (
                                <a href={getLoginZarebinUrl()} className="text-primary-600 border-b cursor-pointer border-primary-600">
                                    وارد
                                </a>
                            ) : (
                                "وارد"
                            )}{" "}
                            شوید.
                        </p>
                    )}
                </div>
                <div
                    className={`pl-relative pl-bg-secondary-200 dark:pl-bg-dark-3 pl-border-t ${
                        conditions(ConditionName.isComplexPortrait) ? "pl-border-secondary" : "pl-border-z-secondary"
                    } pl-px-2 dark:pl-border-z-secondary-600 pl-py-3 pl-flex pl-items-center pl-gap-4 pl-relative pl-z-10 ${
                        !conditions(ConditionName.hasDefaultMessages) && "pl-border-none pl-bg-transparent"
                    }`}
                >
                    <>
                        <div className={`pl-flex pl-flex-col pl-w-full pl-gap-2 pl-relative`}>
                            {conditions(ConditionName.showEmojiComplexPortrait) && <InstagramEmoji />}
                            {conditions(ConditionName.isLogin) &&
                                conditions(ConditionName.chatEnabled) &&
                                conditions(ConditionName.hasDefaultMessages) && <DefaultMessages />}
                        </div>
                    </>
                </div>
                {chatEmojisPopover && (
                    <EmojiPicker
                        enableUnified={false}
                        setSelectedEmoji={setSelectedEmoji}
                        onClickOutside={() => dispatch(setChatEmojisPopover(false))}
                        parentClassName={`pl-bottom-0`}
                    />
                )}
            </div>
        );
    } else {
        return (
            <div className={`pl-relative pl-flex-none pl-w-full pl-flex pl-flex-col pl-justify-end`}>
                <div
                    className={`pl-relative pl-bg-secondary-200 dark:pl-bg-dark-3 pl-border-t pl-border-z-secondary-100 pl-px-4 dark:pl-border-z-secondary-600 pl-py-3 pl-flex pl-items-center pl-gap-4 pl-relative pl-z-10`}
                >
                    {conditions(ConditionName.isLogin) ? (
                        <>
                            {conditions(ConditionName.chatEnabled) ? (
                                <div className={`pl-flex pl-flex-col pl-w-full pl-gap-2`}>
                                    {conditions(ConditionName.hasDefaultMessages) && <DefaultMessages />}
                                    <div className={`pl-flex pl-items-center pl-gap-1 pl-order-2`}>
                                        <div className="pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px]">
                                            <Image
                                                alt="emoji-list-icon"
                                                src={
                                                    conditions(ConditionName.isDarkMode)
                                                        ? chatEmojisPopover
                                                            ? IMAGES.emojiHappyWhite
                                                            : IMAGES.keyboardWhite
                                                        : chatEmojisPopover
                                                        ? IMAGES.emojiHappyBlack
                                                        : IMAGES.keyboardBlack
                                                }
                                                onClick={() => dispatch(setChatEmojisPopover(!chatEmojisPopover))}
                                                className="pl-cursor-pointer"
                                                width={24}
                                                height={24}
                                            />
                                            <input
                                                id="send-chat-input"
                                                className={`pl-text-gray-600 pl-pt-[2px] dark:pl-text-secondary pl-font-normal placeholder:pl-text-gray-600 placeholder:dark:pl-text-secondary pl-w-full pl-bg-transparent pl-outline-none pl-border-none pl-text-[14px]`}
                                                placeholder="دیدگاه خود را وارد کنید"
                                                onChange={(event: any) => setInputValue(event.target.value)}
                                                maxLength={200}
                                                value={inputValue}
                                            />
                                            <div className="pl-text-[11px] pl-font-normal">
                                                <span>{inputValue.length}</span>
                                                <span>/</span>
                                                <span>200</span>
                                            </div>
                                        </div>
                                        <Image
                                            alt="send-comment"
                                            src={IMAGES.sendCommentTouchScreen}
                                            onClick={(e: any) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                submitCommentInChat(setInputValue, inputValue);
                                            }}
                                            className="pl-cursor-pointer"
                                            width={40}
                                            height={40}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <p
                                    className={`pl-truncate pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px] pl-text-[14px] pl-font-normal pl-text-secondary/[0.7]`}
                                >
                                    در حال حاضر امکان ثبت دیدگاه وجود ندارد.
                                </p>
                            )}
                        </>
                    ) : (
                        <p
                            className={`pl-truncate pl-flex pl-flex-1 pl-items-center pl-gap-1 pl-bg-gray-highLight dark:pl-bg-dark-1 pl-py-2 pl-px-3 pl-rounded-[20px] pl-text-secondary pl-text-[14px] pl-font-normal`}
                        >
                            شما برای ارسال دیدگاه خود باید{" "}
                            {conditions(ConditionName.isZarebinSite) ? (
                                <a href={getLoginZarebinUrl()} className="text-primary-600 border-b cursor-pointer border-primary-600">
                                    وارد
                                </a>
                            ) : (
                                "وارد"
                            )}{" "}
                            شوید.
                        </p>
                    )}
                </div>
                {chatEmojisPopover && (
                    <EmojiPicker
                        enableUnified={false}
                        setSelectedEmoji={setSelectedEmoji}
                        onClickOutside={() => dispatch(setChatEmojisPopover(false))}
                        parentClassName={`pl-bottom-[60px] pl-left-[160px]`}
                    />
                )}
            </div>
        );
    }
};

export default AddChatComment;
